<template>
  <v-container justify-center fluid grid-list-xl>
    <v-layout justify-center wrap>
      <messageBox ref="msgBox" />

      <v-flex md12>
        <v-card class="ma-1">
          <v-toolbar color="#0044a3" dark>
            <v-app-bar-nav-icon><v-icon large>mdi-file-document-outline</v-icon></v-app-bar-nav-icon>
            <v-toolbar-title class="white--text">{{
              $t("automazione-global-instructions")
            }}</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-card-text>
            <base-material-card color="primary" icon="mdi-file-document-outline" inline>
              <template v-slot:after-heading>
                <div class="display-1 font-weight-light card-header">
                  {{ $t("automazione-global-instructions") }}
                </div>
              </template>

              <v-divider class="mt-3" />

              <v-textarea
                class="mt-4"
                outlined
                dense
                rows="12"
                :label="$t('automazione-global-instructions-hint')"
                v-model="globalInstructions"
              />

              <v-btn
                color="primary"
                :loading="savingGlobalInstructions"
                @click="saveGlobalInstructions"
              >
                {{ $t("automazione-save-global") }}
              </v-btn>
            </base-material-card>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import messageBox from "../../components/MessageBox";
import automazione from "../../apis/automazione";

export default {
  components: {
    messageBox
  },

  data() {
    return {
      globalInstructions: "",
      savingGlobalInstructions: false
    };
  },

  mounted() {
    this.fetchSetup();
  },

  methods: {
    fetchSetup() {
      automazione.fetchSetup().then(result => {
        this.globalInstructions = result.globalInstructions;
      });
    },

    saveGlobalInstructions() {
      this.savingGlobalInstructions = true;
      automazione
        .saveGlobalInstructions(this.globalInstructions)
        .then(() => {
          this.$refs.msgBox.show(this.$t("gbl-operation-completed"), this.$t("gbl-operation-title"));
        })
        .finally(() => {
          this.savingGlobalInstructions = false;
        });
    }
  }
};
</script>
